import styled, { css } from 'styled-components';

export const Main = styled.main`
  width: 100%;
  padding: 35px;

  display: grid;
  grid-template-columns: 532px 590px;
  grid-template-columns: 43% 57%;
  grid-template-rows: auto;
  column-gap: 16px;
  row-gap: 16px;
  grid-template-areas:
    'purpleMetrics purpleMetrics'
    'prevAbastecimento prevAbastecimento'
    'ctos minhasSolicitacoes'
    'historicoConsumo historicoConsumo'
    'consumptionHistory consumptionHistory';

  @media (max-width: 768px) {
    grid-template-areas:
      'purpleMetrics'
      'prevAbastecimento'
      'ctos'
      'minhasSolicitacoes'
      'historicoConsumo'
      'consumptionHistory';
    grid-template-columns: 100% 100%;
    padding: 16px;
  }
`;

type TourWrapProps = {
  showTour?: boolean;
};

export const TourWrap = styled.div<TourWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;

export const PrevAbastecimentoWrap = styled(TourWrap)`
  grid-area: prevAbastecimento;
`;

export const PurpleMetricsWrap = styled(TourWrap)`
  grid-area: purpleMetrics;
`;

export const HistoryWrap = styled(TourWrap)`
  grid-area: historicoConsumo;
`;

export const CtosWrap = styled(TourWrap)`
  grid-area: ctos;
`;

export const SolicitationsWrap = styled(TourWrap)`
  grid-area: minhasSolicitacoes;
`;

export const ImageBannerPurpleMetrics = styled.img`
  border-radius: 8px;
  width: 100%;
  height: 98px;

  @media (max-width: 620px) {
    height: 62px;
  }
`;

export const LinkPurpleMetrics = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
